var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"gb-l-ideal-container"},[_c('payment-button',{attrs:{"title":_vm.$t('signUp.finishPaymentIDeal'),"method":"ideal"},on:{"click":function($event){return _vm.onSubmit()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }